<template>
  <div>
    <!-- <MainHead ref="mainHeadChild"></MainHead> -->
    <MeetingHomeHead
      :meetingId="meetingInfo.MeetingID"
      :meetingName="meetingInfo.MeetingName"
      :meetingState="meetingInfo.State"
      :meetingStrState="meetingInfo.StrState"
      :meetingType="meetingInfo.MeetingType"
      :meetingTypeText="meetingInfo.MeetingTypeText"
      :fatherGetMeetingVoteInfo="getMeetingVoteInfo"
      :fatherRefreshHeadMeetingList="refreshHeadMeetingList"
      :fatherClickLeftNav="clickLeftNav"
      :currentNavText="currentNavText"
      v-show="!isFullScreen"
    ></MeetingHomeHead>
    <el-drawer
      title="meetingInfo.MeetingName"
      :with-header="false"
      :visible.sync="drawer"
      direction="ltr"
      size="60%"
      custom-class="drawer_left_nav_custom_class"
      :before-close="handleClose"
    >
      <el-menu
        :default-active="leftNavActiveIndex"
        class="el-menu-vertical-demo vote_menu_box"
        @select="drawerNavSelect"
        router
        v-loading="menuLoading"
      >
        <el-menu-item
          :index="menu.Path"
          v-for="(menu, menuIndex) in menuList"
          :key="menuIndex"
          :route="{
            name: menu.RouteName,
            params: menu.RouteParams
          }"
        >
          <template slot="title">
            <i :class="menu.ClassName"></i>
            <span>{{ menu.MenuName }}</span>
          </template>
        </el-menu-item>
        <!-- <el-menu-item index="1" v-if="meetingInfo.MeetingType === 0">
          <template slot="title">
            <i class="iconfont icon-zengjia"></i>
            <span>新增投票</span>
          </template>
        </el-menu-item>
        <el-menu-item index="2" v-if="meetingInfo.MeetingType === 0">
          <template slot="title">
            <i class="iconfont icon-huaban"></i>
            <span>投票管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="7" v-if="meetingInfo.IsVoteUserApply">
          <template slot="title">
            <i class="iconfont icon-baoming"></i>
            <span>签到管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="3" v-if="meetingInfo.Verify !== 1">
          <template slot="title">
            <i class="iconfont icon-pingweiguanli"></i>
            <span>投票人员</span>
          </template>
        </el-menu-item>
        <el-menu-item index="tpgl" v-if="meetingInfo.MeetingType === 2">
          <template slot="title">
            <i class="iconfont icon-huaban"></i>
            <span>投票管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="tpjg" v-if="meetingInfo.MeetingType === 2">
          <template slot="title">
            <i class="iconfont icon-huizong1"></i>
            <span>投票结果</span>
          </template>
        </el-menu-item>
        <el-menu-item index="tpmx" v-if="meetingInfo.MeetingType === 2">
          <template slot="title">
            <i class="iconfont icon-bg-list"></i>
            <span>投票明细</span>
          </template>
        </el-menu-item>
        <el-menu-item index="4">
          <template slot="title">
            <i class="iconfont icon-zu"></i>
            <span>待评项目</span>
          </template>
        </el-menu-item>
        <el-menu-item index="5" v-if="meetingInfo.MeetingType === 0">
          <template slot="title">
            <i class="iconfont icon-guizeicon-rule"></i>
            <span>投票规则</span>
          </template>
        </el-menu-item>
        <el-menu-item index="6" v-if="meetingInfo.MeetingType === 0">
          <template slot="title">
            <i class="iconfont icon-huizong1"></i>
            <span>结果汇总</span>
          </template>
        </el-menu-item> -->
      </el-menu>
    </el-drawer>
    <el-container
      id="main_container"
      class="container_meeting_home"
      :style="rowHeight"
    >
      <el-aside class="vote_left_nav hidden-sm-and-down" v-show="!isFullScreen">
        <el-menu
          :default-active="leftNavActiveIndex"
          class="el-menu-vertical-demo vote_menu_box"
          router
        >
          <el-menu-item
            :index="menu.Path"
            v-for="(menu, menuIndex) in menuList"
            :key="menuIndex"
            :route="{
              name: menu.RouteName,
              params: menu.RouteParams
            }"
          >
            <template slot="title">
              <i :class="menu.ClassName"></i>
              <span>{{ menu.MenuName }}</span>
            </template>
          </el-menu-item>
          <!-- <el-menu-item index="1" v-if="meetingInfo.MeetingType === 0">
            <template slot="title">
              <i class="iconfont icon-zengjia"></i>
              <span>新增投票</span>
            </template>
          </el-menu-item>
          <el-menu-item index="2" v-if="meetingInfo.MeetingType === 0">
            <template slot="title">
              <i class="iconfont icon-huaban"></i>
              <span>投票管理</span>
            </template>
          </el-menu-item>
          <el-menu-item index="7" v-if="meetingInfo.IsVoteUserApply">
            <template slot="title">
              <i class="iconfont icon-baoming"></i>
              <span>签到管理</span>
            </template>
          </el-menu-item>
          <el-menu-item index="3" v-if="meetingInfo.Verify !== 1">
            <template slot="title">
              <i class="iconfont icon-pingweiguanli"></i>
              <span>投票人员</span>
            </template>
          </el-menu-item>
          <el-menu-item index="tpgl" v-if="meetingInfo.MeetingType === 2">
            <template slot="title">
              <i class="iconfont icon-huaban"></i>
              <span>投票管理</span>
            </template>
          </el-menu-item>
          <el-menu-item index="tpjg" v-if="meetingInfo.MeetingType === 2">
            <template slot="title">
              <i class="iconfont icon-huizong1"></i>
              <span>投票结果</span>
            </template>
          </el-menu-item>
          <el-menu-item index="tpmx" v-if="meetingInfo.MeetingType === 2">
            <template slot="title">
              <i class="iconfont icon-bg-list"></i>
              <span>投票明细</span>
            </template>
          </el-menu-item>
          <el-menu-item index="4">
            <template slot="title">
              <i class="iconfont icon-zu"></i>
              <span>待评项目</span>
            </template>
          </el-menu-item>
          <el-menu-item index="5" v-if="meetingInfo.MeetingType === 0">
            <template slot="title">
              <i class="iconfont icon-guizeicon-rule"></i>
              <span>投票规则</span>
            </template>
          </el-menu-item>
          <el-menu-item index="6" v-if="meetingInfo.MeetingType === 0">
            <template slot="title">
              <i class="iconfont icon-huizong1"></i>
              <span>结果汇总</span>
            </template>
          </el-menu-item> -->
        </el-menu>
        <div class="vote_nav_QRCode">
          <div class="code_tip">
            二维码
            <a title="点击重新生成二维码" @click="makeCode()">
              <i class="el-icon-postcard"></i>
            </a>
            <a
              title="点击复制会议链接"
              v-clipboard:copy="meetingLink"
              v-clipboard:success="cliSuccess"
              v-clipboard:error="cliEooro"
              style="margin: 0px 10px"
              v-show="false"
            >
              <i class="el-icon-copy-document"></i>
            </a>
          </div>
          <div class="code_pic" v-loading="codeLoading">
            <el-image
              :src="meetingInfo.MeetingWXCodeUrl"
              :preview-src-list="meetingCodeList"
              @click.stop="handleClickItem"
            >
            </el-image>
            <el-image
              v-show="false"
              :src="meetingInfo.MeetingCodeUrl"
              :preview-src-list="meetingCodeList"
            >
            </el-image>
            <span
              v-if="meetingInfo.MeetingType === 0 && meetingInfo.State === 4"
            >
              会议开始状态，投票人通过微信扫一扫进入会议。
            </span>
            <span
              v-if="meetingInfo.MeetingType === 2 && meetingInfo.State === 4"
            >
              投票已开始，通过微信扫一扫进入投票。
            </span>
            <span
              class="warn"
              v-if="meetingInfo.MeetingType === 0 && meetingInfo.State !== 4"
            >
              会议未开始
            </span>
            <span
              class="warn"
              v-if="meetingInfo.MeetingType === 2 && meetingInfo.State !== 4"
            >
              投票未开始
            </span>
            <span
              v-if="meetingInfo.MeetingType === 0 && meetingInfo.State !== 4"
            >
              请点击右上角“开始会议”
            </span>
            <span
              v-if="meetingInfo.MeetingType === 2 && meetingInfo.State !== 4"
            >
              请点击投票管理中的“开始投票”按钮启动投票
            </span>
          </div>
        </div>
      </el-aside>
      <el-main id="main" class="main" ref="main">
        <div class="main_top hidden-md-and-up">
          <span>
            {{ meetingInfo.MeetingName }}
          </span>
          <span v-if="meetingInfo.State === 1" class="draft_color">
            {{ meetingInfo.StrState }}
          </span>
          <span v-if="meetingInfo.State === 4" class="publish_color">
            {{ meetingInfo.StrState }}
          </span>
          <span v-if="meetingInfo.State === 3" class="end_color">
            {{ meetingInfo.StrState }}
          </span>
          <span v-if="meetingInfo.State === 6" class="close_color">
            {{ meetingInfo.StrState }}
          </span>
          <el-link
            title="编辑会议"
            :underline="false"
            @click="openMettingEdit()"
          >
            <i class="el-icon-edit-outline"></i>
          </el-link>
        </div>
        <router-view
          :voteListPagingQuery="voteListPagingQuery"
          :meetingInfo="meetingInfo"
          @changePaging="changePaging"
        />
      </el-main>
    </el-container>
  </div>
</template>

<script>
// import MainHead from '@/components/MainHead.vue'
import MeetingHomeHead from '@/components/MeetingHomeHead.vue'
// import voteManageApi from '../api/vote/voteManage'
export default {
  name: 'MeetingHome',
  components: {
    // MainHead,
    MeetingHomeHead
  },
  data () {
    return {
      rowHeight: {
        height: (window.innerHeight - 56) + 'px'
      },
      leftNavActiveIndex: '1',
      meetingInfo: {
        MeetingWXCodeUrl: '',
        MeetingCodeUrl: ''
      },
      meetingCodeList: [],
      voteListPagingQuery: {
        maxResultCount: 10,
        skipCount: 0,
        currentPage: 1
      },
      codeLoading: true,
      drawer: false,
      currentNavText: null,
      meetingLink: null,
      publicVote: {},
      menuLoading: false,
      menuList: [],
      isFullScreen: false
    }
  },
  provide () {
    return {
      getMeetingVoteInfo: this.getMeetingVoteInfo,
      homeSwitchFullScreen: this.homeSwitchFullScreen
    }
  },
  methods: {
    handleClose (done) {
      done()
    },
    clickLeftNav () {
      this.drawer = !this.drawer
    },
    drawerNavSelect: function (key, keyPath) {
      this.drawer = false
    },
    leftNavSelect: function (key, keyPath) {
      switch (key) {
        case '1':
          this.$router.push({ name: 'createVoteBasic', params: { mid: this.$route.params.mid, vid: '0' } })
          this.currentNavText = '新增投票'
          this.drawer = false
          break
        case '2':
          this.voteListPagingQuery.skipCount = 0
          this.voteListPagingQuery.maxResultCount = 10
          this.voteListPagingQuery.currentPage = 1
          this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
          this.currentNavText = '投票管理'
          this.drawer = false
          break
        case '3':
          this.$router.push({ name: 'voteUserGroup', params: { mid: this.$route.params.mid, vid: '0' } })
          this.currentNavText = '投票人员'
          this.drawer = false
          break
        case '4':
          this.$router.push({ name: 'voteProjectGroup', params: { mid: this.$route.params.mid, vid: '0' } })
          this.currentNavText = '待评项目'
          this.drawer = false
          break
        case '5':
          this.$router.push({ name: 'voteRule', params: { mid: this.$route.params.mid } })
          this.currentNavText = '投票规则'
          this.drawer = false
          break
        case '6':
          this.$router.push({ name: 'voteResultsSummary', params: { mid: this.$route.params.mid } })
          this.currentNavText = '结果汇总'
          this.drawer = false
          break
        case '7':
          this.$router.push({ name: 'userApplyManager', params: { mid: this.$route.params.mid } })
          this.currentNavText = '签到管理'
          this.drawer = false
          break
        case 'tpgl':
          this.$router.push({ name: 'editPublicVote', params: { mid: this.$route.params.mid, vid: this.publicVote.Id } })
          this.currentNavText = '投票管理'
          this.drawer = false
          break
        case 'tpjg':
          this.$router.push({ name: 'publicVoteResult', params: { mid: this.$route.params.mid, vid: this.publicVote.Id, votetype: this.publicVote.VoteType } })
          this.currentNavText = '投票结果'
          this.drawer = false
          break
        case 'tpmx':
          this.$router.push({ name: 'publicVoteDetails', params: { mid: this.$route.params.mid, vid: this.publicVote.Id, votetype: this.publicVote.VoteType } })
          this.currentNavText = '投票明细'
          this.drawer = false
          break
      }
    },
    getMeetingVoteInfo: function () {
      this.codeLoading = true
      this.$api.meetingManage.getMeetingVoteInfo({
        meetingID: this.$route.params.mid
      }).then(data => {
        this.meetingInfo = data
        this.meetingCodeList = []
        this.meetingCodeList.push(this.meetingInfo.MeetingWXCodeUrl)
        this.meetingCodeList.push(this.meetingInfo.MeetingCodeUrl)
        this.meetingLink = this.meetingInfo.VoteLink + '/' + this.$route.params.mid + '/' + this.meetingInfo.CompanyID
        // if (this.meetingInfo.MeetingType === 2) {
        //   voteManageApi.getVoteList({
        //     meetingId: this.$route.params.mid,
        //     skipCount: 0,
        //     maxResultCount: 10
        //   }).then(data => {
        //     this.publicVote = data.Items[0]
        //   }).catch(err => {
        //     return err
        //   })
        // }
        this.getMenuList()
        this.codeLoading = false
      }).catch(err => {
        this.codeLoading = false
        return err
      })
    },
    getMenuList: function () {
      this.menuLoading = true
      this.$api.meetingManage.getMenuList({
        meetingID: this.$route.params.mid
      }).then(data => {
        this.menuList = data
        this.menuLoading = false
      }).catch(err => {
        this.menuLoading = false
        return err
      })
    },
    refreshHeadMeetingList: function () {
      this.$refs.mainHeadChild.getMeetingList()
    },
    makeCode: function () {
      this.$api.meetingManage.makeCode(this.$route.params.mid).then(data => {
        this.meetingInfo.MeetingWXCodeUrl = ''
        this.meetingInfo.MeetingCodeUrl = ''
        this.getMeetingVoteInfo()
        this.$message({
          showClose: true,
          type: 'success',
          message: '生成成功!',
          customClass: 'custom_message'
        })
      }).catch(err => {
        return err
      })
    },
    changePaging: function (skipCount, maxResultCount, currentPage) {
      this.voteListPagingQuery.skipCount = skipCount
      this.voteListPagingQuery.maxResultCount = maxResultCount
      this.voteListPagingQuery.currentPage = currentPage
    },
    handleClickItem () {
      //   this.$nextTick(() => {
      //     // 获取遮罩层dom
      //     const domImageMask = document.querySelector('.el-image-viewer__mask')
      //     if (!domImageMask) {

      //     }
      //     // domImageMask.addEventListener('click', () => {
      //     //   // 点击遮罩层时调用关闭按钮的 click 事件
      //     //   document.querySelector('.el-image-viewer__close').click()
      //     // })
      //   })
    },
    changeActiveIndex: function () {
      switch (this.$route.name) {
        case 'createVoteBasic':
          this.leftNavActiveIndex = '/m/createVote/basic'
          this.currentNavText = '新增投票'
          break
        case 'createVoteUser':
          this.leftNavActiveIndex = '/m/createVote/basic'
          this.currentNavText = '新增投票'
          break
        case 'createVoteProject':
          this.leftNavActiveIndex = '1'
          this.currentNavText = '新增投票'
          break
        case 'meetingVote':
          this.leftNavActiveIndex = '/m/vote'
          this.currentNavText = '投票管理'
          break
        case 'editVoteBasic':
          this.leftNavActiveIndex = '/m/vote'
          this.currentNavText = '投票管理'
          break
        case 'editVoteUser':
          this.leftNavActiveIndex = '/m/vote'
          this.currentNavText = '投票管理'
          break
        case 'editVoteProject':
          this.leftNavActiveIndex = '/m/vote'
          this.currentNavText = '投票管理'
          break
        case 'voteSetting':
          this.leftNavActiveIndex = '/m/vote'
          this.currentNavText = '投票管理'
          break
        case 'voteDetail':
          this.leftNavActiveIndex = '/m/vote'
          this.currentNavText = '投票管理'
          break
        case 'voteDetails':
          this.leftNavActiveIndex = '/m/vote'
          this.currentNavText = '投票管理'
          break
        case 'voteResult':
          this.leftNavActiveIndex = '/m/vote'
          this.currentNavText = '投票管理'
          break
        case 'voteProgress':
          this.leftNavActiveIndex = '/m/vote'
          this.currentNavText = '投票管理'
          break
        case 'userApplyManager':
          this.leftNavActiveIndex = '/m/userApplyManager'
          this.currentNavText = '签到管理'
          break
        case 'voteUser':
          this.leftNavActiveIndex = '/m/voteUserGroup'
          this.currentNavText = '投票人员'
          break
        case 'voteUserGroup':
          this.leftNavActiveIndex = '/m/voteUserGroup'
          this.currentNavText = '投票人员'
          break
        case 'voteProjectGroup':
          this.leftNavActiveIndex = '/m/voteProjectGroup'
          this.currentNavText = '待评项目'
          break
        case 'voteProject':
          this.leftNavActiveIndex = '/m/voteProjectGroup'
          this.currentNavText = '待评项目'
          break
        case 'voteRule':
          this.leftNavActiveIndex = '/m/voteRule'
          this.currentNavText = '投票规则'
          break
        case 'voteResultsSummary':
          this.leftNavActiveIndex = '/m/voteResultsSummary'
          this.currentNavText = '结果汇总'
          break
        case 'editPublicVoteBasic':
          this.leftNavActiveIndex = '/m/p/editVote'
          this.currentNavText = '投票管理'
          break
        case 'editPublicVoteProject':
          this.leftNavActiveIndex = '/m/p/editVote'
          this.currentNavText = '投票管理'
          break
        case 'publicVoteResult':
          this.leftNavActiveIndex = '/m/p/watchVote/voteResult'
          this.currentNavText = '投票结果'
          break
        case 'publicVoteDetails':
          this.leftNavActiveIndex = '/m/p/watchVote/voteDetails'
          this.currentNavText = '投票明细'
          break
        case 'publicVoteProjectGroup':
          this.leftNavActiveIndex = '/m/p/voteProjectGroup'
          this.currentNavText = '投票选项'
          break
        case 'publicVoteProject':
          this.leftNavActiveIndex = '/m/p/voteProjectGroup'
          this.currentNavText = '投票选项'
          break
      }
      switch (this.$route.name) {
        // case 'voteUser':
        //   this.leftNavActiveIndex = '3'
        //   this.currentNavText = '投票人员'
        //   break
        // case 'voteUserGroup':
        //   this.leftNavActiveIndex = '3'
        //   this.currentNavText = '投票人员'
        //   break
        // case 'voteProjectGroup':
        //   this.leftNavActiveIndex = '4'
        //   this.currentNavText = '待评项目'
        //   break
        // case 'voteProject':
        //   this.leftNavActiveIndex = '4'
        //   this.currentNavText = '待评项目'
        //   break
        // case 'voteRule':
        //   this.leftNavActiveIndex = '5'
        //   this.currentNavText = '投票规则'
        //   break
        // case 'meetingVote':
        //   this.leftNavActiveIndex = '2'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'createVoteBasic':
        //   this.leftNavActiveIndex = '1'
        //   this.currentNavText = '新增投票'
        //   break
        // case 'createVoteUser':
        //   this.leftNavActiveIndex = '1'
        //   this.currentNavText = '新增投票'
        //   break
        // case 'createVoteProject':
        //   this.leftNavActiveIndex = '1'
        //   this.currentNavText = '新增投票'
        //   break
        // case 'editVoteBasic':
        //   this.leftNavActiveIndex = '2'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'editVoteUser':
        //   this.leftNavActiveIndex = '2'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'editVoteProject':
        //   this.leftNavActiveIndex = '2'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'editVoteSetting':
        //   this.leftNavActiveIndex = '2'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'voteDetail':
        //   this.leftNavActiveIndex = '2'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'voteResult':
        //   this.leftNavActiveIndex = '2'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'voteProgress':
        //   this.leftNavActiveIndex = '2'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'voteResultsSummary':
        //   this.leftNavActiveIndex = '6'
        //   this.currentNavText = '结果汇总'
        //   break
        // case 'meetingBasic':
        //   this.currentNavText = '基本信息'
        //   break
        // case 'userApplyManager':
        //   this.leftNavActiveIndex = '7'
        //   this.currentNavText = '签到管理'
        //   break
        // case 'editPublicVoteBasic':
        //   this.leftNavActiveIndex = 'tpgl'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'editPublicVoteProject':
        //   this.leftNavActiveIndex = 'tpgl'
        //   this.currentNavText = '投票管理'
        //   break
        // case 'publicVoteResult':
        //   this.leftNavActiveIndex = 'tpjg'
        //   this.currentNavText = '投票结果'
        //   break
        // case 'publicVoteDetails':
        //   this.leftNavActiveIndex = 'tpmx'
        //   this.currentNavText = '投票明细'
        //   break
      }
    },
    openMettingEdit: function () {
      this.$router.push({ name: 'meetingBasic', params: { mid: this.$route.params.mid } })
      this.currentNavText = '基本信息'
    },
    homeSwitchFullScreen: function () {
      const _this = this
      _this.isFullScreen = !_this.isFullScreen
      if (_this.isFullScreen) {
        _this.rowHeight = {
          height: (window.innerHeight - 26) + 'px',
          marginTop: '26px'
        }
      } else {
        _this.rowHeight = {
          height: (window.innerHeight - 56) + 'px',
          marginTop: '56px'
        }
      }
    },
    cliSuccess () {
      this.$message({
        type: 'success',
        message: '复制成功',
        customClass: 'custom_message'
      })
    },
    cliEooro () {
      this.$message({
        type: 'error',
        message: '复制失败',
        customClass: 'custom_message'
      })
    }
  },
  created () {
    this.getMeetingVoteInfo()
  },
  mounted () {
    this.changeActiveIndex()
  },
  watch: {
    $route () {
      this.changeActiveIndex()
    }
  }
}
</script>
<style lang="less">
.vote_menu_box .el-menu-item {
  height: 48px;
  line-height: 48px;
}
</style>
